module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/calendar-0d21d5ade3fbd982006c13164a14987b.svg";